import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbRelatorioChamadas } from "app/abstract/full-pages/relatorios/relatorio-chamadas.abstract";

@Injectable({
    providedIn: 'root'
})
export class RelatorioChamadasService extends AbRelatorioChamadas {

    constructor(http: HttpClient) {
        super(http);
    }

    getRelatorioChamadas(filter: String): Observable<any> {
        return this.get(`registro_chamada/relatorio/listar/${filter}`);
    }

    getRelatorio(filter: string): Observable<any> {
        return this.get(`registro_chamada/relatorio/${filter}`);
    }

    getAllRelatorioRamais(): Observable<any> {
        return this.get(`registro_chamada/relatorio/ramais`);
    }

    getAllRelatorioDispositivo(): Observable<any> {
        return this.get(`registro_chamada/relatorio/dispositivo`);
    }

}